import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconLockPersonSvg } from "./IconLockPersonSvg.mjs";
const IconLockPerson = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconLockPersonSvg, ...iconProps });
};
export {
  IconLockPerson
};
